import { render } from "./Login.vue?vue&type=template&id=f7b6201e&class=full-screen"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render

export default script